module.exports = __webpack_public_path__ + "img/team8.ecd4d386.jpg";